import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  updateProfile
} from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC5pi_c5QW6CMg7_iyj34BwxIZ69T44mic",
  authDomain: "shadowverse-wintracker.firebaseapp.com",
  databaseURL: "https://shadowverse-wintracker-default-rtdb.firebaseio.com",
  projectId: "shadowverse-wintracker",
  storageBucket: "shadowverse-wintracker.appspot.com",
  messagingSenderId: "770628328741",
  appId: "1:770628328741:web:36c75cf9da7838aab28ecc",
  measurementId: "G-CCGW8XLECT"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();

const database = getDatabase(app);

const googleProvider = new GoogleAuthProvider();

const emailRegister = async (name, email, password) => {
  await createUserWithEmailAndPassword(auth, email, password);
  updateProfile(auth.currentUser, { displayName: name });
};
const googleSignIn = async () => signInWithPopup(auth, googleProvider);
const emailSignIn = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);
const sendPasswordReset = async (email) => sendPasswordResetEmail(auth, email);
const logout = () => signOut(auth);

export {
  auth,
  database,
  googleSignIn,
  emailSignIn,
  emailRegister,
  sendPasswordReset,
  logout
};
